import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Store from "../../content/Store";
import Contentify from "../../content/Contentify";
import styles from "../../assets/css/modules/logout/logout.css";
import layoutStyles from "../../assets/css/modules/shared/layout.css";
import { PolicyType } from "../../constants/Constants";
import { B2CSignOut } from "../../helpers/LogoutHelper";

export const Logout = ({ content, isInternalView, exitSurveyType, inline, timeout}) => {
  const onClickHandler = () => {
    window.embeddedservice_bootstrap?.userVerificationAPI?.clearSession(true);
    B2CSignOut({ isInternalView: !!isInternalView, exitSurveyType });
  };

  return (
    <button
      className={`nav-link ${styles.logoutButton} ${
        inline &&
        styles.logoutButtonInline + " " + layoutStyles.anchorDecorationUnderline
      }`}
      id="logout-link"
      onClick={onClickHandler}
    >
      {isInternalView ? content.endSessionLabel : timeout === "timeout"?content.caplogout : content.buttonLabel}
    </button>
  );
};

Logout.content = Store.Logout;

export const mapStateToLogout = ({ policyReducer, layoutReducer }) => {
  const isInternational =
    policyReducer.selectedPolicy &&
    policyReducer.selectedPolicy.IsInternational;

  return {
    isInternalView:
      policyReducer.policyDetails && policyReducer.policyDetails.IsInternalView,
    exitSurveyType: isInternational
      ? PolicyType.International
      : layoutReducer.layout
  };
};

export default withRouter(Contentify(connect(mapStateToLogout)(Logout)));
